import script from "./NewEoPVerificationReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewEoPVerificationReport.vue?vue&type=script&setup=true&lang=ts"

import "./NewEoPVerificationReport.vue?vue&type=style&index=0&id=5589086f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5589086f"]])

export default __exports__